import DiscountIcon from '@ordr-as/icons/DiscountIcon';
import { MenuAction } from '@ordr-as/umami-react/context-menu';
import classNames from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import { FormattedMessage } from 'react-intl';
import useAccessControl from '../../../../../hooks/useAccessControl';
import { useCartIsBusy } from '../../../../../hooks/useCartIsBusy';

type DiscountMenuItemProps = { setOpenDiscountDialog: Dispatch<SetStateAction<boolean>> };

const DiscountMenuItem = (props: DiscountMenuItemProps) => {
  const { setOpenDiscountDialog } = props;
  const cartIsBusy = useCartIsBusy();
  const { userCanDiscount } = useAccessControl();

  const textColor = classNames({
    'text-grey-dark': !userCanDiscount,
    'text-brand-black ': userCanDiscount,
  });

  return (
    <MenuAction
      isDisabled={cartIsBusy}
      isRestricted={!userCanDiscount}
      onClick={() => setOpenDiscountDialog(true)}
      className="umami-context-menu-item bg-brand-white text-small text-brand-black rounded-full py-4 px-4 pr-8"
    >
      <div className={'flex text-base ' + textColor}>
        <DiscountIcon className="mr-2 mt-1" />
        <span>
          <FormattedMessage id="generic.discount" />
        </span>
      </div>
    </MenuAction>
  );
};

export default DiscountMenuItem;
